export default __webpack_public_path__ + "static/media/linha.03a819a7.png";